import { styled } from '@terra/ui-styled-system';
import { type TextVariantProps, text } from '@terra/ui-styled-system';
import type { ComponentProps, StyledComponent } from '@terra/ui-styled-system';

type TextProps = TextVariantProps & { as?: React.ElementType };

export type HeadingProps = ComponentProps<typeof Heading>;
export const Heading = styled('h2', text, {
  defaultProps: { variant: 'heading', 'data-bi-unmask': 'true' },
}) as StyledComponent<'h2', TextProps>;
